import { StateCreator } from 'zustand';
import { TQuoteStore } from '@store/types/GlobalStore.type';

export interface LayoutSlice {
  // Track selected main tab
  selectedLayoutTab: string | undefined;
  // Persist last selected root tab (duplicating selectedTa
  setLayoutSelectedTab: (tab: string) => void;
}

export const createLayoutSlice: StateCreator<TQuoteStore, [], [], LayoutSlice> = (set) => ({
  selectedLayoutTab: 'quoteDetails',
  setLayoutSelectedTab: (tab) =>
    set((prev) => ({
      ...prev,
      selectedLayoutTab: tab,
    })),
});

// FUTURE TODO: gut everything in the 'Drawer' specific to Quote only that currently is stored in the 'Global Store'
// add here and feed to drawer with props..
// then action items that "open sidebar" could do it via here as well
